import React, { useState, useEffect } from "react";
import "./SettingsButton.styles.scss";
import { Dropdown, Nav } from "react-bootstrap";
import ToolTip from "components/ToolTip/ToolTip";
import { useAuthentication } from "hooks";

import CambiarContraseniaModal from "components/Model/CambiarContraseniaModal";
import { SvgComponent } from "components/SvgComponent/SvgComponent";
import EntidadesList from "views/Entidades/EntidadesList";
import { useConfigurationPage, useMiCuentaPage } from "hooks";
import { Permisos } from "utils/permisos";
import MiCuenta from "views/MiCuenta/MiCuenta";
import { MiCuentaProvider } from "providers";
import { useApp } from "hooks";

const SettingsButton = () => {
  const { logout, usuario: user, tienePermiso } = useAuthentication();
  const { setConfigurationState, getConfigurationState } = useConfigurationPage();
  const { setMiCuentaState, getMiCuentaState } = useMiCuentaPage();
  const [showCanvas, setShowCanvas] = useState(false);
  const [mostrarModalCambiarContrasenia, setMostrarModalCambiarContrasenia] = useState(false);
  const [mostrarMiCuenta, setMostrarMiCuenta] = useState(false);
  const { configuration } = useApp();

  useEffect(() => {
    const interval = setInterval(() => {
      setShowCanvas(getConfigurationState() === "true");
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setMostrarMiCuenta(getMiCuentaState() === "true");
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const openInNewTab = (url) => {
    const win = window.open(url, "_blank", "noopener,noreferrer");
    win.focus();
  };

  const cerrarSesion = () => {
    logout();
  };

  const cambiarContrasenia = () => {
    setMostrarModalCambiarContrasenia(true);
  };

  const mostrarMiCuentaModal = () => {
    setMostrarMiCuenta(true);
    setShowCanvas(false);
  }

  return (
    <>
      {mostrarModalCambiarContrasenia && (
        <CambiarContraseniaModal
          setMostrarModalCambiarContrasenia={setMostrarModalCambiarContrasenia}
          mostrarModalCambiarContrasenia={mostrarModalCambiarContrasenia}
          user={user}
        ></CambiarContraseniaModal>
      )}
      {showCanvas && (
        <EntidadesList showCanvas={showCanvas} setShowCanvas={setShowCanvas} />
      )}
      {(configuration?.Vendor === "citrus") && mostrarMiCuenta && (
        <MiCuentaProvider>
          <MiCuenta showCanvas={mostrarMiCuenta} setShowCanvas={setMostrarMiCuenta} />
        </MiCuentaProvider>
      )}
      <Dropdown as={Nav.Item}>
        <Dropdown.Toggle
          as={Nav.Link}
          id="dropdown-41471887333"
          style={{ fontSize: "20px" }}
          className="buttonHover"
        >
          <ToolTip placement="left" message="Configuración">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 -960 960 960"
              fill="#77777A"
            >
              <path
                d="m388-80-20-126q-19-7-40-19t-37-25l-118 54-93-164 108-79q-2-9-2.5-20.5T185-480q0-9 .5-20.5T188-521L80-600l93-164 118 54q16-13 37-25t40-18l20-127h184l20 126q19 7 40.5 18.5T669-710l118-54 93 164-108 77q2 10 2.5 21.5t.5 21.5q0 10-.5 21t-2.5 21l108 78-93 164-118-54q-16 13-36.5 25.5T592-206L572-80H388Zm48-60h88l14-112q33-8 62.5-25t53.5-41l106 46 40-72-94-69q4-17 6.5-33.5T715-480q0-17-2-33.5t-7-33.5l94-69-40-72-106 46q-23-26-52-43.5T538-708l-14-112h-88l-14 112q-34 7-63.5 24T306-642l-106-46-40 72 94 69q-4 17-6.5 33.5T245-480q0 17 2.5 33.5T254-413l-94 69 40 72 106-46q24 24 53.5 41t62.5 25l14 112Zm44-210q54 0 92-38t38-92q0-54-38-92t-92-38q-54 0-92 38t-38 92q0 54 38 92t92 38Zm0-130Z"
              />
            </svg>
          </ToolTip>
        </Dropdown.Toggle>
        <Dropdown.Menu alignRight aria-labelledby="navbarDropdownMenuLink">
          {tienePermiso(Permisos.Seguridad.CONFIGURACION_LISTAR) && (
            <Dropdown.Item
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setConfigurationState(true);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 -960 960 960"
                style={{ marginRight: "8px" }}
              >
                <path
                  d="m388-80-20-126q-19-7-40-19t-37-25l-118 54-93-164 108-79q-2-9-2.5-20.5T185-480q0-9 .5-20.5T188-521L80-600l93-164 118 54q16-13 37-25t40-18l20-127h184l20 126q19 7 40.5 18.5T669-710l118-54 93 164-108 77q2 10 2.5 21.5t.5 21.5q0 10-.5 21t-2.5 21l108 78-93 164-118-54q-16 13-36.5 25.5T592-206L572-80H388Zm48-60h88l14-112q33-8 62.5-25t53.5-41l106 46 40-72-94-69q4-17 6.5-33.5T715-480q0-17-2-33.5t-7-33.5l94-69-40-72-106 46q-23-26-52-43.5T538-708l-14-112h-88l-14 112q-34 7-63.5 24T306-642l-106-46-40 72 94 69q-4 17-6.5 33.5T245-480q0 17 2.5 33.5T254-413l-94 69 40 72 106-46q24 24 53.5 41t62.5 25l14 112Zm44-210q54 0 92-38t38-92q0-54-38-92t-92-38q-54 0-92 38t-38 92q0 54 38 92t92 38Zm0-130Z"
                />
              </svg>
              Configuración
            </Dropdown.Item>
          )}

          <Dropdown.Item
            href="#"
            onClick={(e) => {
              e.preventDefault();
              cambiarContrasenia();
            }}
          >
            <SvgComponent
              height="20"
              width="20"
              iconName="lock"
              fill="#2f2f2f"
              style={{ marginRight: "8px" }}
            />
            Cambiar Contraseña
          </Dropdown.Item>
          {(configuration?.Vendor === "citrus") && tienePermiso(Permisos.MiCuenta.VER) && (<Dropdown.Item
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setMiCuentaState(true);
            }}
          >
            <SvgComponent
              height="20"
              width="20"
              iconName="mi cuenta"
              fill="#2f2f2f"
              style={{ marginRight: "8px" }}
            />
            Mi Cuenta
          </Dropdown.Item>)}
          {tienePermiso(Permisos.Soporte.WHATSAPP_VER) && <Dropdown.Item
            href="#"
            onClick={(e) => {
              e.preventDefault();
              openInNewTab("https://api.whatsapp.com/send?phone=18095488274");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              viewBox="0 0 24 24"
              style={{ marginRight: "8px" }}
            >
              <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
            </svg>
            Soporte WhatsApp
          </Dropdown.Item>}
          <Dropdown.Item
            href="#"
            onClick={() => {
              cerrarSesion();
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 -960 960 960"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: "8px" }}
            >
              <path d="M440-450q13 0 21.5-9t8.5-21q0-13-8.5-21.5T440-510q-12 0-21 8.5t-9 21.5q0 12 9 21t21 9ZM260-120v-60l280-49v-466q0-14-7.5-24.5T512-732l-252-39v-59l266 46q32 5 53 30.5t21 57.5v516l-340 60Zm-140 0v-60h80v-590q0-26 17.5-43t42.5-17h440q26 0 43 17t17 43v590h80v60H120Zm140-60h440v-590H260v-1 591Z" />
            </svg>
            Cerrar Sesión
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default SettingsButton;
